//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DisplayableObject.js";
let d=[[],[[[],"GetConstraintType",{R_:{type:''}},0,0],[["num_geoms"],"GetConstraintGeometryArray",{R_:{consGeometries:"NXObject[]"}},0,0]],[]];
SPLM.ModlConstraint = class extends SPLM.DisplayableObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.ModlConstraint";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.ModlConstraint.RelationType = Object.freeze({
    "Coplanar" : "Coplanar", "Coplaxis" : "Coplaxis", "EqualRadius" : "EqualRadius", "Offset" : "Offset", "Parallel" : "Parallel", "Perpendicular" : "Perpendicular", "Symmetric" : "Symmetric", "Tangent" : "Tangent", "Coaxial" : "Coaxial"});

export default SPLM;